module.exports = __webpack_public_path__ + "img/SH2D_30002.9a6baa18.png";